import { makeStyles } from '@material-ui/core';

export const useSendNftDialogStyles = makeStyles((theme) => ({
  modalRoot: {
    '&&': {
      overflowY: 'unset',
    },
  },
  wrapper: {
    width: '100%',
    display: 'grid',
    margin: '32px 0 0',
    gap: 24,
  },
  nonceWrapper: {
    position: 'relative',
  },
  nonceClosedWrapper: {
    display: 'flex',
    gap: 4,
    alignItems: 'center',
  },
  inputWrapper: {
    display: 'grid',
    gap: 8,
  },
  inputIDSWrapper: {
    // marginTop: -15,
  },
  inputNonceWrapper: {
    display: 'none',
  },
  error: {
    color: 'rgba(228, 78, 69, 1)',
  },
  editNonce: {
    '&&': {
      width: 'min-content',
      height: 'min-content',
      padding: '0 16px',
      borderRadius: 6,
      marginLeft: 'auto',
      display: 'flex',
      gap: 8,
    },
  },
  editIcon: {
    '&&': {
      margin: 0,
    },
  },
  inputLabel: {
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '20px',
    color: '#FAFAFA',
  },
  buttonsWrapper: {
    display: 'flex',
    gap: 16,
  },
}));
